import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mx-auto mb-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_select = _resolveComponent("app-select")!
  const _component_app_form_row = _resolveComponent("app-form-row")!
  const _component_app_button = _resolveComponent("app-button")!
  const _component_app_card = _resolveComponent("app-card")!
  const _component_app_table = _resolveComponent("app-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_app_card, {
      label: "Function",
      classes: "pb-0"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_app_button, {
            name: "New version",
            theme: "info",
            icon: "fa-plus",
            to: { name: _ctx.ROUTE_NAME_VERSION.ADD, query: { store: _ctx.query.store } }
          }, null, 8, ["to"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_app_form_row, {
          label: "Store",
          class: "col-md-4 mx-auto"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_app_select, {
              options: _ctx.VersionOptions.Store,
              modelValue: _ctx.query.store,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.query.store) = $event)),
              modelModifiers: { number: true },
              onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.fetchList(0)))
            }, null, 8, ["options", "modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_app_card, null, {
      default: _withCtx(() => [
        _createVNode(_component_app_table, {
          rows: _ctx.list,
          columns: _ctx.table.columns,
          actions: _ctx.table.actions,
          total: _ctx.total,
          offset: _ctx.query.offset,
          limit: _ctx.query.limit,
          onRefreshData: _ctx.fetchList
        }, null, 8, ["rows", "columns", "actions", "total", "offset", "limit", "onRefreshData"])
      ]),
      _: 1
    })
  ], 64))
}